import { HttpErrorIgnore, HttpErrorUpsert, HttpImportResult } from '../../../../global';
import apiSvc, { BinaryFileType } from '../../../core/services/apiSvc';
import utilSvc from '../../../core/utilSvc';
import validSvc from '../../../core/validSvc';

import { IraDataItem } from '../ira_types';

const GET_LIST = 'admin/gbliramedpayor/list';
const GET_EXCEL = 'admin/gbliramedpayor/export';
const POST_IMPORT = 'admin/gbliramedpayor/import';

// AI AGENT
// this is the API JSON for getList generate an API type (IraListItemAPI) from this
// also create a VM function to map from API JSON type to IraDataItem
/*
    {
        "Id": "68cb421220e1eb1ee565b1b8",
        "Bin": "610097",
        "Pcn": "MPPP",
        "Group": "GROUP1",
        "ContractYear": [
            2024,
            2025
        ],
        "CreatedBy": "UNIT TEST USER",
        "CreatedDate": "2025-09-17T23:19:46.684Z",
    }
*/

type IraListItemAPI = {
    Id: string;
    Bin: string;
    Pcn: string;
    Group: string;
    ContractYear: string[];
    CreatedBy: string;
    CreatedDate: string;
    ModifiedBy: string;
    ModifiedDate: string;
};

function iraDataItemVM(data: IraListItemAPI): IraDataItem {
    data = data || {};
    return {
        Id: data.Id,
        BIN: data.Bin,
        PCN: data.Pcn,
        GroupNumber: data.Group,
        ContractYear:
            Array.isArray(data.ContractYear) && data.ContractYear.length > 0 ? data.ContractYear.join(', ') : '',
        CreatedBy: data.CreatedBy,
        CreatedDate: data.CreatedDate,
        ModifiedBy: data.ModifiedBy,
        ModifiedDate: data.ModifiedDate,
    };
}

function iraListVM(items: IraListItemAPI[]): IraDataItem[] {
    if (!Array.isArray(items) || items.length < 1) {
        return [];
    }

    const result: IraDataItem[] = [];
    items.forEach(item => {
        result.push(iraDataItemVM(item));
    });

    return result;
}

export async function getList(): Promise<IraDataItem[] | HttpErrorIgnore> {
    try {
        const r = await apiSvc.getEntityList<IraListItemAPI>(GET_LIST);
        return iraListVM(r);
    } catch (err: any) {
        // all entity list errors handled upstream
        return utilSvc.http.ignore(err, 'iraRepo.getList') as HttpErrorIgnore;
    }
}

export async function postImport(year: string, importFile: Blob): Promise<HttpImportResult | HttpErrorUpsert> {
    try {
        // params
        if (!validSvc.isInteger(year) || !importFile) {
            throw new Error('iraRepo.postImport, year integer and file required');
        }

        const apiRequest = {
            Params: {
                ContractYear: parseInt(year),
            },
        };

        const r = await apiSvc.postFile(POST_IMPORT, apiRequest, importFile);
        return r as HttpImportResult;
    } catch (err: any) {
        // handle errors in hook
        return err as HttpErrorUpsert;
    }
}

export async function getExcel(fileName: string): Promise<undefined | HttpErrorIgnore> {
    // params
    if (!validSvc.isText(fileName)) {
        throw new Error('iraRepo.getExcel, filename is required');
    }
    return apiSvc.postGetBinary(GET_EXCEL, {}, fileName, BinaryFileType.Excel);
}

export const iraRepo = {
    getList,
    getExcel,
    postImport,
};
export default iraRepo;
